import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'
import * as UserActions from '../../../actions/UserActions'
import * as MyAPI from '../../../utils/MyAPI'
import Header from '../parts/HeaderNoLogin'
import {
  loginWithToken,
  _check_if_hiragana_only,
  expand_list_default,
} from '../../../utils/Helper'
import Alert from 'react-s-alert';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import { API_URL } from '../../../utils/Settings'
import {
  Container,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Input,
  Button,
} from 'reactstrap';
import shortid from 'shortid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import EvalScoreUpdateEach from './EvalScoreUpdateEach'


// // 正解: 予測
// let expand_list_default = {
//   "いい": "良い",
//   "おっしゃっ": "仰っ",
//   "いう": "言う",
//   "やつ": "奴",
//   "かける": "掛ける",
//   "カタチ": "形",
//   "いたし": "致し",
//   "頂く": "いただく",
//   "頂い": "いただい",
//   "是非": "ぜひ",
//   "事": "こと",
//   "カスタマー": "カスタマ",
//   "ゼロ": "0",
//   "キューアンドエー": "QアンドA",
//   "私": "わたくし",
//   "宛て": "宛",
//   "頂け": "いただけ",
//   "FAX": "ファックス",
//   "Web": "ウェブ",
//   ".com": "ドットコム",
//   "はじめ": "初め",
//   "マネジメント": "マネージメント",
// }

// // 正解: 予測
// let expand_list_default = {
//   "いい": ["良い"],
//   "おっしゃっ": ["仰っ"],
//   "いう": ["言う"],
//   "やつ": ["奴"],
//   "かける": ["掛ける"],
//   "カタチ": ["形"],
//   "いたし": ["致し"],
//   "頂く": ["いただく"],
//   "頂い": ["いただい"],
//   "是非": ["ぜひ"],
//   "事": ["こと"],
//   "カスタマー": ["カスタマ"],
//   "ゼロ": ["0"],
//   "キューアンドエー": ["QアンドA", "Q&A"],
//   "私": ["わたくし"],
//   "宛て": ["宛"],
//   "頂け": ["いただけ"],
//   "FAX": ["ファックス"],
//   "Web": ["ウェブ"],
//   ".com": ["ドットコム"],
//   "はじめ": ["初め"],
//   "マネジメント": ["マネージメント"],
//   "良い": ["いい"],
//   "仰っ": ["おっしゃっ"],
//   "言う": ["いう"],
//   "奴": ["やつ"],
//   "掛ける": ["かける"],
//   "形": ["カタチ"],
//   "致し": ["いたし"],
//   "いただく": ["頂く"],
//   "ぜひ": ["是非"],
//   "こと": ["事"],
//   "カスタマ": ["カスタマー"],
//   "QアンドA": ["キューアンドエー", "Q&A"],
//   "Q&A": ["キューアンドエー", "QアンドA"],
//   "わたくし": ["私"],
//   "宛": ["宛て"],
//   "いただけ": ["頂け"],
//   "ファックス": ["FAX"],
//   "ウェブ": ["ウェブ"],
//   "ドットコム": [".com"],
//   "初め": ["はじめ"],
//   "マネージメント": ["マネジメント"],
// }

// NaranciaOpenTool
const NaranciaOpenTool = (props) => {

  // use history
  let navigate = useNavigate()


  let dispatch = useDispatch();

  // parameters
  let [loading, setLoading] = useState(false);

  let [seikaiTexts, setSeikaiTexts] = useState('')
  let [predictedTexts, setPredictedTexts] = useState('')

  let [seikaiProcessed, setSeikaiProcessed] = useState('')
  let [predictedProcessed, setPredictedProcessed] = useState('')

  let [kanakanjiList, setKanakanjiList] = useState(null)
  let [readyFlg, setReadyFlg] = useState(false)


  // componentDidMount
  useEffect(() => {

    // _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // // first script
  // let _firstScript = () => {
  //
  // }

  // start evaluation
  let _getStartEvaluation = async (texts) => {

    setLoading(true)

    try {

        // get voice to check
        const results_1 = await MyAPI.processNaranciaEvalTexts({
          texts: texts,
        })
        if (results_1.status !== "success") {
          throw Error(results_1.message)
        }
        console.log("processNaranciaEvalTexts.results_1: ", results_1)

        setLoading(false)

        return results_1.processed

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }

    setLoading(false)
  }

  // get kana kanji list
  let _getNaranciaKanaKanjiPairFromWords = async (processed_text_list) => {

    setLoading(true)

    try {

      let candidate_words = []

      // extract kanji
      for (let i=0; i<processed_text_list.length; i++) {

        let _processed_str = processed_text_list[i]
        let _processed_arr = _processed_str.split(" ")
        for ( let j=0; j<_processed_arr.length; j++ ) {
          let _word = _processed_arr[j]

          if (_check_if_hiragana_only(_word) === false) {

            if (isNaN(_word) === true) {
              if (candidate_words.indexOf(_word) === -1) {
                candidate_words.push(_word)
              }
            }
          }
        }
      }

      // console.log("candidate_words: ", candidate_words)

      // get voice to check
      const results_1 = await MyAPI.getNaranciaKanaKanjiPairFromWords({
        candidate_words_str: JSON.stringify(candidate_words),
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }
      console.log("getNaranciaKanaKanjiList.results_1: ", results_1)

      if (results_1.list1) {
        setKanakanjiList(results_1.list1)
      } else {
        setKanakanjiList([])
      }

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }

    setLoading(false)
  }

  // start calculating wer
  let _startCalcWer = async() => {

    if (!seikaiTexts) {
      Alert.error("正解を入力してください。", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
      return
    }

    if (!predictedTexts) {
      Alert.error("推論結果／予測を入力してください。", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
      return
    }

    let seikai_length = seikaiTexts.length
    // console.log("seikai_length: ", seikai_length)
    if (seikai_length > 250) {
      Alert.error("文章が長すぎます。文章は250文字以内でお願いします。", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
      return
    }

    let predicted_length = predictedTexts.length
    // console.log("predicted_length: ", predicted_length)
    if (predicted_length > 250) {
      Alert.error("文章が長すぎます。文章は250文字以内でお願いします。", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
      return
    }

    setReadyFlg(false)

    setKanakanjiList(null)

    // process both texts on server
    let _seikaiProcessed = await _getStartEvaluation(seikaiTexts)
    setSeikaiProcessed(_seikaiProcessed)

    console.log("predictedTexts: ", predictedTexts)

    // process both texts on server
    let _predictedProcessed = await _getStartEvaluation(predictedTexts)
    setPredictedProcessed(_predictedProcessed)

    console.log("_predictedProcessed: ", _predictedProcessed)

    // process candidate
    let _list1 = []
    _list1.push(_seikaiProcessed)
    _list1.push(_predictedProcessed)
    await _getNaranciaKanaKanjiPairFromWords(_list1)

    setReadyFlg(true)
  }

  let _deleteSavedPairList = () => {
    console.log("_deleteSavedPairList.1")
  }
  let _savePredictionAndWer = () => {
    console.log("_savePredictionAndWer.1")
  }








  // create correspondence
  let _create_correspondence =  async ({
    seikaiTexts,
    predictedTexts,
  }) => {

    if (!seikaiTexts) {
      return
    }

    console.log("_create_correspondence: ")

    // create expand list
    let _expand_list = expand_list_default
    for (let i=0; i<kanakanjiList.length; i++) {
      let _item = kanakanjiList[i]
      let _kanji = _item.kanji
      let _kana = _item.kana

      // _expand_list[_kanji] = _kana
      if (!_expand_list[_kanji]) {
        _expand_list[_kanji] = []
      }
      if (_expand_list[_kanji].indexOf(_kana) === -1) {
        // console.log("")
        _expand_list[_kanji].push(_kana)
      }
    }

    console.log("kanakanjiList ", kanakanjiList)
    console.log("_expand_list: ", _expand_list)

    // prepare sentences trim
    let _seikaiTexts = seikaiTexts
    _seikaiTexts = _seikaiTexts.split("、").join(" ")
    _seikaiTexts = _seikaiTexts.split("。").join(" ")
    // _seikaiTexts = _seikaiTexts.split(".").join(" ")
    _seikaiTexts = _seikaiTexts.split("/\s+/").join(" ")
    let seikai_arr = _seikaiTexts.split(" ")

    // remove null items for just in case
    let seikai_arr2 = []
    for ( let i=0; i<seikai_arr.length; i++ ) {
      if (seikai_arr[i]) {
        seikai_arr2.push(seikai_arr[i])
      }
    }
    seikai_arr = seikai_arr2
    _seikaiTexts = seikai_arr.join(" ")

    let _predictedTexts = predictedTexts
    if (!predictedTexts) {
      _predictedTexts = ""
    }
    _predictedTexts = _predictedTexts.split("、").join(" ")
    _predictedTexts = _predictedTexts.split("。").join(" ")
    // _predictedTexts = _predictedTexts.split(".").join(" ")
    _predictedTexts = _predictedTexts.split("/\s+/").join(" ")
    let predicted_arr = _predictedTexts.split(" ")
    // remove null items for just in case
    let predicted_arr2 = []
    for ( let i=0; i<predicted_arr.length; i++ ) {
      if (predicted_arr[i]) {
        predicted_arr2.push(predicted_arr[i])
      }
    }
    predicted_arr = predicted_arr2
    _predictedTexts = predicted_arr.join(" ")

    // console.log("_predictedTexts: ", _predictedTexts)

    // sliding function

    let seikai_arr_fin = []
    let prediction_arr_fin = []

    let blocks_4 = _create_blocks_by_window(predicted_arr, seikai_arr, 4, _expand_list)

    // console.log("blocks_4.0: ", blocks_4)

    let first_block =  blocks_4[0]
    let first_type = first_block.type
    let first_predicted = first_block.predicted

    if (first_type === "not_match" && first_predicted.length === 0 ) {

      // console.log("ugeugeugeugeugeugeugeugeugeuge")

      blocks_4 = [{
        type: "not_match",
        seikai: seikai_arr,
        predicted: predicted_arr,
      }]
    }

    // console.log("blocks_4.1: ", blocks_4)

    for ( let m=0; m<blocks_4.length; m++ ) {

      let _block4 = blocks_4[m]

      if (_block4.type === "match") {
        seikai_arr_fin = seikai_arr_fin.concat(_block4.seikai)
        prediction_arr_fin = prediction_arr_fin.concat(_block4.predicted)
        continue
      }

      // create blocks by sliding window size 3
      let blocks_3 = _create_blocks_by_window(_block4.predicted, _block4.seikai, 3, _expand_list)

      // console.log("blocks_3: ", blocks_3)

      for ( let i=0; i<blocks_3.length; i++ ) {

        let _block3 = blocks_3[i]

        if (_block3.type === "match") {
          seikai_arr_fin = seikai_arr_fin.concat(_block3.seikai)
          prediction_arr_fin = prediction_arr_fin.concat(_block3.predicted)
          continue
        }

        // create blocks by sliding window size 2
        let blocks_2 = _create_blocks_by_window(_block3.predicted, _block3.seikai, 2, _expand_list)
        // console.log("blocks_2: ", blocks_2)

        for (let j=0; j<blocks_2.length; j++) {

          let _block2 = blocks_2[j]
          if (_block2.type === "match") {
            seikai_arr_fin = seikai_arr_fin.concat(_block2.seikai)
            prediction_arr_fin = prediction_arr_fin.concat(_block2.predicted)
            continue
          }

          // console.log("_block2.predicted: ", _block2.predicted)
          // console.log("_block2.seikai: ", _block2.seikai)


          let blocks_1 = _create_blocks_by_window(_block2.predicted, _block2.seikai, 1, _expand_list)
          // console.log("blocks_1: ", blocks_1)

          for ( let k=0; k<blocks_1.length; k++ ) {

            let _block1 = blocks_1[k]

            // サイズが異なる時かは　_　で埋める
            if ( _block1.predicted.length > _block1.seikai.length ) {

              let _diff = _block1.predicted.length - _block1.seikai.length
              for (let i=0; i<_diff; i++) {
                _block1.seikai.push("_")
              }

            } else if ( _block1.predicted.length < _block1.seikai.length ) {

              let _diff = _block1.seikai.length - _block1.predicted.length
              // console.log("_diff ", _diff)
              for (let i=0; i<_diff; i++) {
                _block1.predicted.push("_")
              }
            }

            seikai_arr_fin = seikai_arr_fin.concat(_block1.seikai)
            prediction_arr_fin = prediction_arr_fin.concat(_block1.predicted)
          }
        }
      }
    }

    // console.log("seikai_arr_fin: ", seikai_arr_fin)
    // console.log("prediction_arr_fin: ", prediction_arr_fin)

    return {
      seikai_arr: seikai_arr_fin,
      prediction_arr: prediction_arr_fin,
    }
  }




    // create match and unmatch blocks by sliding window
    let _create_blocks_by_window = (predited_arr, seikai_arr, window_size, _expand_list) => {

      let seikai_texts = seikai_arr.join(" ")
      let seikai_no_space = seikai_arr.join("")

      let predited_texts = predited_arr.join(" ")

      // 4: ok, 5, ok
      let seikai_meta = {}

      // find out things to combine
      // という 形 でも <=> という 形 で も

      let need_to_combine = []

      let max_i = predited_arr.length+1-window_size

      // generate need to combine...
      // window 3
      for ( let i=0; i<max_i; i++  ) {

        // いい === 良い
        // おっしゃっ === 仰っ
        // いう === 言う
        // やつ === 奴
        // かける === 掛ける
        // かたち === カタチ
        // かたち === 形
        // かたち === 形

        // 正解が漢字、予測がかな
        // 正解がかな、予測が漢字
        let _orig_arr = []
        for ( let j=0; j<window_size; j++ ) {
          _orig_arr.push(predited_arr[i+j])
        }

        let expanded_list = _generateExpandList(_orig_arr, _expand_list)
        console.log("expanded_list: ", expanded_list)

        for (let j=0; j<expanded_list.length; j++) {

          //　水増し
          let _expanded = expanded_list[j]

          let predited_chunk3 = ""

          for (let k=0; k<window_size; k++) {
            predited_chunk3 = predited_chunk3+_expanded[k]
          }
          predited_chunk3 = predited_chunk3.trim()

          if ( seikai_no_space.indexOf(predited_chunk3) === -1 ) {
            continue
          }

          let predited_chunk31_orig = ""

          for (let k=0; k<window_size; k++) {
            predited_chunk31_orig = predited_chunk31_orig+" "+predited_arr[i+k]
          }
          predited_chunk31_orig = predited_chunk31_orig.trim()

          let predited_chunk31 = ""

          for (let k=0; k<window_size; k++) {
            predited_chunk31 = predited_chunk31+" "+_expanded[k]
          }
          predited_chunk31 = predited_chunk31.trim()

          if ( seikai_texts.indexOf(predited_chunk31_orig) === -1) {

            // あくまでオリジナルを入れる必要がある！
            if (need_to_combine.indexOf(predited_chunk31_orig) === -1) {

              // ここは要チェック
              // "頂き <==> いただき"　や　"でも <==> で　も"を同時になんとかしようとしたいので
              // 後者が取れなくなっているかも。
              need_to_combine.push({
                exists_in_pred: predited_chunk31_orig,
                found_in_seikai : predited_chunk31
              })
            }
          }
        }
      }

      // seikai_texts
      // combine...
      // という 形 でも <=> という 形 で も
      // if (window_size > 1) {
      if (window_size > 0) {

        let seikai_texts2 = seikai_texts
        let predited_texts2 = predited_texts

        for (let i=0; i<need_to_combine.length; i++) {

          let _item = need_to_combine[i]

          let _exists_in_pred = _item.exists_in_pred
          let _found_in_seikai = _item.found_in_seikai

          let _text2 = ""
          for ( let j=0; j<_found_in_seikai.length; j++ ) {
            let _char = _found_in_seikai[j]

            _text2 = _text2 + " " + _char
          }
          _text2 = _text2.trim()
          _text2 = _text2.replace(/\s+/g,' ')

          let _text3 = ""
          for ( let j=0; j<_text2.length; j++ ) {
            let _char = _text2[j]
            if (_char === " ") {
              _text3 = _text3 + _char + "?"
            } else {
              _text3 = _text3 + _char
            }
          }
          _text3 = _text3.trim()

          //
          let position_type = "normal"
          if (seikai_texts2 === _found_in_seikai) {
            // exact same
            position_type = "exact"

          } else if (seikai_texts2.startsWith(_found_in_seikai) === true) {
            _text3 = _text3 + " "

            position_type = "start"

          } else if (seikai_texts2.endsWith(_found_in_seikai) === true) {
            _text3 = " " +_text3
            position_type = "end"

          } else {
            _text3 = " " +_text3 + " "
            position_type = "normal"

          }

          let _re3 = new RegExp(_text3)


          let _match = seikai_texts2.match(_re3)
          if (_match) {

            // 正解が変わってしまうのはマズイ
            let _exists_in_pred_2 = ""
            if (position_type === "exact") {
              _exists_in_pred_2 = _exists_in_pred
            } else if (position_type === "start") {
              _exists_in_pred_2 = _exists_in_pred + " "
            } else if (position_type === "end") {
              _exists_in_pred_2 = " " + _exists_in_pred
            } else {
              _exists_in_pred_2 = " " + _exists_in_pred + " "
            }

            predited_texts2 = predited_texts2.split(_exists_in_pred_2).join(_match[0])

          }
        }
        // インデックスを取得する
        seikai_texts = seikai_texts2
        predited_texts = predited_texts2
      }

      predited_arr = predited_texts.split(" ")
      seikai_arr = seikai_texts.split(" ")

      let last_bb_arr_idx = -1
      let max_seikai_index = -1

      // ここまでで、window 比較をするための下拵え（漢字の調整、単語分割数のゆらぎなどを調整している）
      // based on window 3
      for ( let i=0; i<max_i; i++ ) {

        let predited_chunk3 = ""

        for (let k=0; k<window_size; k++) {
          predited_chunk3 = predited_chunk3+predited_arr[i+k]
        }
        predited_chunk3 = predited_chunk3.trim()

        if ( seikai_no_space.indexOf(predited_chunk3) === -1 ) {
          continue
        }

        let predited_chunk31 = ""

        for (let k=0; k<window_size; k++) {
          predited_chunk31 = predited_chunk31+" "+predited_arr[i+k]
        }
        predited_chunk31 = predited_chunk31.trim()

        // if predited_chunk31 is "", then continue
        if (!predited_chunk31) {
          continue
        }

        let predited_chunk312 = predited_chunk31
        if (seikai_texts === predited_chunk31) {
          // exact same
          predited_chunk312 = predited_chunk31

        } else if (seikai_texts.startsWith(predited_chunk31) === true) {
          // detected from start
          predited_chunk312 = predited_chunk312 + " "
        } else if (seikai_texts.endsWith(predited_chunk31) === true) {
          predited_chunk312 = " " + predited_chunk312
        } else {
          predited_chunk312 = " " + predited_chunk31 + " "
        }

        // 文章が長いと遠くで見つかる場合がある！！！
        // if ( predited_chunk31 && seikai_texts.indexOf(" "+predited_chunk31+" ") !== -1) {
        if ( seikai_texts.indexOf(predited_chunk312) !== -1) {

          let _indexes = getAllIndexes(seikai_texts, predited_chunk31);
          // console.log("_indexes: ", _indexes, predited_chunk31)

          // 正解テキストの中で予測チャンクが出てくる場所を突き止める
          let _idx = -1
          for ( let j=0; j<_indexes.length; j++ ) {
            if (_indexes[j] > last_bb_arr_idx) {
              _idx = _indexes[j]
              break
            }
          }

          // console.log("_idx ", _idx)

          // 遠くで見つかった場合はどうする？
          // predited_chunk31が　ひらがなオンリーの場合は...

          let _diff333 = _idx - last_bb_arr_idx

          // console.log("_diff333.3: ", _diff333)

          // 8 is just a hardcoded number
          // it's something called huristic
          let predited_chunk31_nospace = predited_chunk31.split(" ").join("")
          if ( _check_if_hiragana_only(predited_chunk31_nospace) === true && _diff333 > 8 && last_bb_arr_idx !== -1) {
            // if (last_bb_arr_idx !== -1) {
              console.log("_diff333.0: ", _diff333)
              continue
            // }
          } else if (_diff333 > 30) {
            console.log("_diff333.1: ", _diff333)
            continue
          }

          // 予測チャンクのテキストと同じ？
          let _aaa =  seikai_texts.substr(_idx, predited_chunk31.length)

          // 前の部分
          let _bbb =  seikai_texts.substr( 0, _idx)

          _bbb = _bbb.trim()

          let _bb_arr =  _bbb.split(" ")

          // スペースで分解した時のインデックスを取る
          let _seikai_idx = 0
          if (_bbb){
            _seikai_idx = _bbb.split(" ").length
          }

          last_bb_arr_idx = _idx

          if (_seikai_idx < max_seikai_index) {
            continue
          }

          for (let k=0; k<window_size; k++) {

            let _word = seikai_arr[_seikai_idx+k]


            let _predicted_word = predited_arr[i+k]
            if (_word !== _predicted_word) {
              continue
            }


            if (!seikai_meta[_seikai_idx+k]) {

              seikai_meta[_seikai_idx+k] = {
                'word': _word,
                'seikai_idx': _seikai_idx+k,
                'pred_idx': i+k
              }
              max_seikai_index = _seikai_idx+k
            }
          }
        }

      }

      // どうしても「フォマート の」と「フォマ の」がマッチしていることになっていまう。

      let arr_blocks = [{
        type: 'match',
        predicted: [],
        seikai: [],
      }]

      // マッチしている部分、マッチしていない部分を取得する
      // 2, 7 ,21 >
      let last_key = -1
      let last_continuous_key = -1
      for ( let key in seikai_meta ) {

        let item = seikai_meta[key]

        key = parseInt(key)

        if (last_key === key - 1) {

          last_continuous_key = key

        } else {

          let _pred_idx_start = 0
          let _seikai_idx_start = 0
          if (last_continuous_key > -1) {

            let item2 = seikai_meta[last_continuous_key]
            _pred_idx_start = item2.pred_idx + 1
            _seikai_idx_start = item2.seikai_idx + 1
          }

          let _pred_idx_end = item.pred_idx - 1
          let _seikai_idx_end = item.seikai_idx -1

          let _predicted = ""
          let _predicted_min_arr = []

          for ( let i=_pred_idx_start; i<_pred_idx_end+1; i++ ) {

            _predicted = _predicted + " " + predited_arr[i]
            _predicted_min_arr.push(predited_arr[i])
          }
          _predicted = _predicted.trim()

          let _seikai = ""
          let _seikai_min_arr = []
          for ( let i=_seikai_idx_start; i<_seikai_idx_end+1; i++ ) {
            _seikai = _seikai + " " + seikai_arr[i]
            _seikai_min_arr.push(seikai_arr[i])
          }
          _seikai = _seikai.trim()

          arr_blocks.push({
            type: 'not_match',
            predicted: _predicted_min_arr,
            seikai: _seikai_min_arr,
          })

          // push next
          arr_blocks.push({
            type: 'match',
            predicted: [],
            seikai: [],
          })

          console.log("last_continuous_key ", last_continuous_key, " > ", key)
          last_continuous_key = key
        }

        let last_idx = arr_blocks.length - 1

        arr_blocks[last_idx].predicted.push(predited_arr[item.pred_idx])
        arr_blocks[last_idx].seikai.push(seikai_arr[item.seikai_idx])


        // post process
        last_key = key
      }

      // 最後のマッチしていない部分を付け足す
      let last_item = seikai_meta[last_key]
      let last_pred_idx = 0
      let last_seikai_idx = 0
      if (last_item) {
        last_pred_idx = last_item.pred_idx+1
        last_seikai_idx = last_item.seikai_idx+1
      }

      let _predicted_min_arr = predited_arr.slice(last_pred_idx, predited_arr.length)
      let _seikai_min_arr = seikai_arr.slice(last_seikai_idx, seikai_arr.length)

      arr_blocks.push({
        type: 'not_match',
        predicted: _predicted_min_arr,
        seikai: _seikai_min_arr,
      })

      let arr_blocks2 = []
      for ( let i=0; i<arr_blocks.length; i++ ) {
        let arr_block = arr_blocks[i]

        if (arr_block.predicted.length === 0 && arr_block.seikai.length === 0) {
          continue
        }
        arr_blocks2.push(arr_block)
      }
      arr_blocks = arr_blocks2

      return arr_blocks
    }

    // 配列を受け取って、可能性のるリストに水増しする
    // いい === 良い
    // おっしゃっ === 仰っ
    // いう === 言う
    // やつ === 奴
    // かける === 掛ける
    // かたち === カタチ
    // かたち === 形
    let _generateExpandList = ( list1, list3 ) => {

      // console.log("_generateExpandList.list1: ", list1 )
      // console.log("_generateExpandList.list3: ", list3 )

      let arr_count = 1

      for ( let i=0; i<list1.length; i++ ) {

        let _word = list1[i]

        if (list3[_word]) {
          let _similar_count = list3[_word].length
          arr_count = arr_count * (_similar_count + 1)
        }
      }

      // console.log("arr_count: ", arr_count)

      // create empty arrays
      let return_arr1 = []
      for ( let i=0; i<arr_count; i++ ) {
        return_arr1.push([])
        // for ( let j=0; j<list1.length; j++ ) {
        //   return_arr1[i].push([])
        // }
      }
      // console.log("return_arr1: ", return_arr1)


      // return_arr[0][0] = "今後"
      // return_arr[1][0] = "今後"
      // return_arr[2][0] = "こんご"
      // return_arr[3][0] = "こんご"

      for ( let i=0; i<return_arr1.length; i++ ) {



        for ( let j=0; j<list1.length; j++ ) {

          let _word = list1[j]
          // console.log("_word: ", _word)

          let _list4 = [_word]

          let _count = 1

          if (list3[_word]) {

            for ( let k=0; k<list3[_word].length; k++ ) {

              let _tmp1 = list3[_word][k]
              if (_list4.indexOf(_tmp1) === -1 ) {
                _list4.push(_tmp1)
              }
            }
          }
          // console.log("_list4: ", _list4)

          // ここまでで["今後", "こんご"]ができてる

          //
          let _tmp_index = i % _list4.length

          return_arr1[i].push(_list4[_tmp_index])
        }

      }
      // console.log("return_arr1: ", return_arr1)
      return return_arr1


      // // re-check words ...
      // for ( let i=0; i<list1.length; i++ ) {
      //
      //   // この i は単語のインデックス
      //   // 今後 の 課題 で今後のところは 0
      //   let _word = list1[i]
      //
      //   return_arr[i][0] = _word
      //   return_arr[i][0] = _word
      //
      //   if (list3[_word]) {
      //
      //     for (let j=0; j<list3[_word].length; j++) {
      //       return_arr[j+1][0] = list3[_word][j]
      //     }
      //
      //   }
      // }
      //
      //
      //
      // // return_arr
      // let return_arr = []
      // return_arr.push([])
      //
      // for ( let i=0; i<list1.length; i++ ) {
      //
      //   let _word = list1[i]
      //
      //   if (list3[_word]) {
      //
      //     // let value = list3[_word]
      //     let values = list3[_word]
      //
      //     // copy all
      //     let copied = JSON.parse(JSON.stringify(return_arr))
      //
      //     for (let j=0; j<return_arr.length; j++) {
      //       return_arr[j].push(_word)
      //     }
      //
      //     for (let j=0; j<copied.length; j++) {
      //
      //       // for (let k=0; k<values.length; k++) {
      //       //   copied[j].push(values[k])
      //       // }
      //       copied[j].push("value")
      //     }
      //
      //     return_arr = return_arr.concat(copied)
      //
      //   } else {
      //
      //     for (let j=0; j<return_arr.length; j++) {
      //       return_arr[j].push(_word)
      //     }
      //
      //   }
      // }
      // return return_arr
    }


    // get indexes ...
    let getAllIndexes = (arr, val) => {
      var indexes = [], i = -1;
      while ((i = arr.indexOf(val, i+1)) != -1){
          indexes.push(i);
      }
      return indexes;
    }


    // _seikaiTextsChanged
    let _seikaiTextsChanged = (e) => {
      setSeikaiTexts(e.target.value)
      setSeikaiProcessed("")
    }

    // _predictedTextsChanged
    let _predictedTextsChanged = (e) => {
      setPredictedTexts(e.target.value)
      setPredictedProcessed("")
    }








  return (
    <div style={{
      backgroundColor: '#F2F5FA',
    }}>

      {/* header */}
      <Header />

      <Container>


      <Row style={{
        marginTop: 40,
        marginBottom: 0,
      }}>

        <Col md="2" xs="12" style={{
          textAlign: 'right',
        }}>
        </Col>
        <Col md="8" xs="12" style={{
          textAlign: 'left',
        }}>
          <span>
            正解 ({seikaiTexts.length})
          </span>
        </Col>
        <Col md="2" xs="12" />
      </Row>
        <Row style={{
          marginTop: 0,
          marginBottom: 30,
        }}>

          <Col md="2" xs="12" style={{
            textAlign: 'right',
          }}>

          </Col>
          <Col md="8" xs="12" style={{
            textAlign: 'left',
          }}>
            <TextareaAutosize
              type="textarea"
              style={{
                width: '100%',
                borderColor: '#cccccc',
                borderRadius: 3,
                borderWidth: 1,
              }}
              name='seikaiTexts'
              onChange={_seikaiTextsChanged}
              value={seikaiTexts}
              placeholder='' />
          </Col>
          <Col md="2" xs="12" />
        </Row>


        <Row style={{
          marginTop: 30,
          marginBottom: 0,
        }}>

          <Col md="2" xs="12" style={{
            textAlign: 'right',
          }}>
          </Col>
          <Col md="8" xs="12" style={{
            textAlign: 'left',
          }}>
            <span>
              予測 ({predictedTexts.length})
            </span>
          </Col>
          <Col md="2" xs="12" />
        </Row>
        <Row style={{
          marginTop: 0,
          marginBottom: 40,
        }}>

          <Col md="2" xs="12" style={{
            textAlgn: 'right',
          }}>

          </Col>
          <Col md="8" xs="12" style={{
            textAlign: 'left',
          }}>
            <TextareaAutosize
              type="textarea"
              style={{
                width: '100%',
                borderColor: '#cccccc',
                borderRadius: 3,
                borderWidth: 1,
              }}
              name='predictedTexts'
              onChange={_predictedTextsChanged}
              value={predictedTexts}
              placeholder='' />
          </Col>
          <Col md="2" xs="12" />
        </Row>

        <Row style={{
          marginTop: 10,
          marginBottom: 10,
        }}>

          <Col md="2" xs="12" style={{
            textAlign: 'right',
          }}>

          </Col>
          <Col md="8" xs="12" style={{
            textAlign: 'right',
          }}>

            <Button
              onClick={_startCalcWer}
              color="primary"
              style={{
                cursor: 'pointer',
              }}>
              WERを計算する
            </Button>

          </Col>
          <Col md="2" xs="12" />
        </Row>

        {/* scoring... */}
        {predictedProcessed && seikaiProcessed && kanakanjiList && readyFlg === true && (
          <EvalScoreUpdateEach
            accountType="admin"
            item={{
              'processed_texts':predictedProcessed,
            }}
            deleteSavedPairList={_deleteSavedPairList}
            savePredictionAndWer={_savePredictionAndWer}
            create_correspondence={_create_correspondence}
            kanakanjiList={kanakanjiList}
            seikaiProcessed={seikaiProcessed} />
        )}

        <div style={{
          height: 60,
        }} />

      </Container>

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default NaranciaOpenTool
